import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';

i18next.use(initReactI18next).init({
    fallbackLng: 'en',
    debug: true,
    // if you see an error like: "Argument of type 'DefaultTFuncReturn' is not assignable to parameter of type xyz"
    // set returnNull to false (and also in the i18next.d.ts options)
    // returnNull: false,
});

const ValidLocales = [
    'en-US',
    'en-AU',
    'en-GB',
    'fr-FR',
    'fr-CA',
    'fr-CH',
    'de-DE',
    'en-CA',
    'en-NZ',
    'en-SG',
    'en-IE',
    'de-AT',
    'de-CH',
    'en-IN',
    'it-IT',
    'nl-NL',
    'nl-BE',
    'fr-BE',
    'es-ES',
    'es-US',
    'it-CH',
    'pt-PT',
    'nb-NO',
    'da-DK',
    'sv-SE',
    'fi-FI',
] as const;

export type Locale = (typeof ValidLocales)[number];

function isValidLocale(value?: string | null): value is Locale {
    return !!value && (ValidLocales as readonly string[]).includes(value);
}

// Use same function for gettting default locale
export function sanitiseLocale(value?: string | null): Locale {
    if (!value) {
        return 'en-US';
    }

    const locale = value
        .split('-')
        .map((part, index) => (index === 0 ? part.toLowerCase() : part.toUpperCase()))
        .join('-');

    return isValidLocale(locale) ? locale : 'en-US';
}

// todo - remove this once file pages/business-name-generator/index.tsx is migrated or use from here in all places
export const availableBNGLocales: Locale[] = [
    'en-US',
    'en-CA',
    'en-GB',
    'en-IE',
    'en-AU',
    'en-NZ',
    'en-SG',
];

export const availableBNILocales: Locale[] = ['en-US'];
